import { Component } from '@angular/core';
import { LayoutOneModule } from '@nchl/ngx-ui/layout-one';
import { MainComponent } from './main/main.component';
import { SidebarTopComponent } from './sidebar-top/sidebar-top.component';
import { SidebarBottomComponent } from './sidebar-bottom/sidebar-bottom.component';
import { SidebarMiddleComponent } from './sidebar-middle/sidebar-middle.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { FooterComponent } from './footer/footer.component';

@Component({
  selector: 'app-layout',

  imports: [
    LayoutOneModule,
    MainComponent,
    SidebarTopComponent,
    SidebarBottomComponent,
    SidebarMiddleComponent,
    TopBarComponent,
    FooterComponent
  ],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.css',
})
export class AppLayoutComponent {}
